export const SUBMISSION_TEMPLATE = 'submission';

export const MULTIPLE_SUBMISSION_TEMPLATES = 'multiple_submission_templates';

export const HIRING_FOR_DEFAULT = ['Direct Client', 'Vendor', 'Third Party', 'Internal Hiring'];

export const WORKPLACE_PREFERENCES = ['Remote', 'Onsite', 'Hybrid'];

export const JOB_INDUSTRY_DEFAULT = [
  'All',
  'Accounting and Auditing Services',
  'Advertising and PR Services',
  'Aerospace and Defense',
  'Agriculture/Forestry/Fishing',
  'Architectural and Design Services',
  'Automotive and Parts Mfg',
  'Automotive Sales and Repair Services',
  'Banking',
  'Biotechnology/Pharmaceuticals',
  'Broadcasting, Music, and Film',
  'Business Services - Other',
  'Chemicals/Petro-Chemicals',
  'Clothing and Textile Manufacturing',
  'Computer/IT Services',
  'Computer Hardware',
  'Computer Software',
  'Consumer Packaged Goods Manufacturing',
  'Construction - Industrial Facilities and Infrastructure',
  'Construction - Resvalueential & Commercial/Office',
  'Education',
  'Electronics, Components, and Semiconductor Mfg',
  'Energy and Utilities',
  'Engineering Services',
  'Entertainment Venues and Theaters',
  'Financial Services',
  'Food and Beverage Production',
  'Government and Military',
  'Healthcare Services',
  'Hotels and Lodging',
  'Internet Services',
  'Insurance',
  'Legal Services',
  'Management Consulting Services',
  'Manufacturing - Other',
  'Marine Mfg & Services',
  'Medical Devices and Supplies',
  'Metals and Minerals',
  'Nonprofit Charitable Organizations',
  'Performing and Fine Arts',
  'Personal and Household Services',
  'Printing and Publishing ',
  'Real Estate/Property Management',
  'Rental Services',
  'Restaurant/Food Services',
  'Retail',
  'Security and Surveillance',
  'Sports and Physical Recreation',
  'Staffing/Employment Agencies',
  'Telecommunications Services',
  'Transport and Storage - Materials',
  'Travel, Transportation and Tourism',
  'Waste Management',
  'Wholesale Trade/Import-Export',
  'Other/Not Classified',
];

export const JOB_CATEGORY_DEFAULT = [
  'Accounting/Finance/Insurance',
  'Administrative/Clerical',
  'Agriculture, Forestry, & Fishing',
  'Banking/Real Estate/Mortgage Professionals',
  'Biotech/R&D/Science',
  'Building Construction/Skilled Trades',
  'Business/Strategic Management',
  'Creative/Design',
  'Customer Support/Client Care',
  'Editorial/Writing',
  'Engieering',
  'Food Services/Hospitability',
  'Human Resources',
  'Installation/Maintenance/Repair',
  'IT/Sexportoftware Development',
  'Legal',
  'Logistics/Transportation',
  'Medical/Health',
  'Manufacturing/Production/Operations',
  'Marketing/Product',
  'Project/Program Management',
  'Quality Assurance/Safety',
  'Sales/Retail/Business Development',
  'Security/Protective Services',
  'Other',
];
